<div class="form-container">
  <h2>Save Company</h2>
  <div style="display: flex; gap: 20px; margin-bottom: 1rem;">
    <a routerLink="/homeAdmin/v2/companies" class="btn btn-secondary">
      ← Back to Company List
    </a>
    <a [routerLink]="['/homeAdmin/v2/companies', companyId, 'users']" class="btn btn-info">
      👥 View Users
    </a>
  </div>
  
  
  <form [formGroup]="companiesForm" (ngSubmit)="updateCompany()">
    <div class="form-group">
      <label>Company Name:</label>
      <input type="text" class="form-control" formControlName="name" placeholder="CompanyName">
      <div *ngIf="errors.name" class="text-danger">
        <ul>
          <li *ngFor="let error of errors.name">{{ error }}</li>
        </ul>
      </div>
    </div>
    
    <div class="form-group">
      <label>VAT Number:</label>
      <input type="text" class="form-control" formControlName="vatNumber" placeholder="vatNumber">
      <div *ngIf="errors.vatNumber" class="text-danger">
        <ul>
          <li *ngFor="let error of errors.vatNumber">{{ error }}</li>
        </ul>
      </div>
    </div>

    <div class="form-group">
      <label>Company Type:</label>
      <select class="form-control" formControlName="type">
        <option value="">Select Type</option>
        <option value="Supplier">Supplier</option>
        <option value="Vessel Owner">Vessel Owner</option>
      </select>
      <div *ngIf="errors.type" class="text-danger">
        <ul>
          <li *ngFor="let error of errors.type">{{ error }}</li>
        </ul>
      </div>
    </div>
    <div formGroupName="credits">
      <div class="form-group">
        <label>Calculations:</label>
        <input type="number" class="form-control" formControlName="calculations" />
      </div>
      <div class="form-group">
        <label>Validations:</label>
        <input type="number" class="form-control" formControlName="validations" />
      </div>
      <div class="form-group">
        <label>Engineering Assistance:</label>
        <input type="number" class="form-control" formControlName="engineeringAssistance" />
      </div>
      <div class="form-group">
        <div>
          <span>Vessel credits ({{ vesselCreditsUsed }} / {{ vesselsTotal }})</span>
        </div>
        <input type="number" class="form-control" formControlName="vessels" />
      </div>
    </div>
    <div *ngIf="errors.general" class="text-danger">
      <ul>
        <li *ngFor="let error of errors.general">{{ error }}</li>
      </ul>
    </div>
  
    <button type="submit" class="btn btn-primary">
      {{ isSubmitting ? 'Updating...' : 'Save' }}
    </button>
  </form>
</div>
